import { t } from "i18next";
import { useEffect, useState } from "react";
import { Table, Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Feedback from "react-bootstrap/esm/Feedback";
import { Pagination } from "../../ui/Pagination";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import checkMatricula from "../../../functions/checkMatricula";
import { setVehicles, updateVehicle } from "../../../store/vehicles";

export const TablaValidar = ({
  data,
  token,
  validarTapped,
  setValidarTapped,
  setDeleteTapped,
  deleteTapped,
  setIsAnyError,
  onSelectVehicle,
  onFormModified,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [allVehicles, setAllVehicles] = useState(false);
  const [currentRecords, setCurrentRecords] = useState([]);

  const [creditLimit, setCreditLimit] = useState(false);
  const [doCheckCreditLimit, setDoCheckCreditLimit] = useState(false);

  const nPages = Math.ceil(data.length / recordsPerPage);
  const dispatch = useDispatch();
  const list = useSelector((state) => state.vehicles.vehicles[0]);

  useEffect(() => {
    assignVehicleParameters();
  }, []);

  const selectAllVehicles = (e) => {
    if (e.target.checked) {
      setAllVehicles(true);
      const vehicles = document.querySelectorAll("div.vehiculo");
      vehicles.forEach((vehiculo) => {
        const checkbox = vehiculo.querySelector("input[type=checkbox]");
        checkbox.checked = true;
      });
    } else {
      setAllVehicles(false);
      const vehicles = document.querySelectorAll("div.vehiculo");
      vehicles.forEach((vehiculo) => {
        const checkbox = vehiculo.querySelector("input[type=checkbox]");
        checkbox.checked = false;
      });
    }
  };

  const assignVehicleParameters = () => {
    let listToModify = data;
    updateRecords();
    for (let index = 0; index < data.length; index++) {
      let element = data[index];
      if (element.limite_credito === "Si") setCreditLimit(true);
      if (
        element.hasOwnProperty("matricula_error") ||
        element.hasOwnProperty("tipo_combustible_error") ||
        element.hasOwnProperty("tipo_vehiculo_error") ||
        element.hasOwnProperty("pin_error") ||
        element.hasOwnProperty("limite_credito_error") ||
        element.hasOwnProperty("limite_mensual_error")
      ) {
        setIsAnyError(true);
      }
      if (element.pin === "") {
        element.pin = "0";
      }
      listToModify[index] = {
        ...element,
        limite_mensual:
          element.limite_mensual !== "" ? element.limite_mensual : "0",
        credito_definido: parseInt(
          element.limite_mensual !== "" ? element.limite_mensual : "-1"
        ),
      };
    }
    dispatch(setVehicles(data));
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  useEffect(() => {
    if (currentPage > nPages && nPages > 0) {
      // Added nPages > 0 to prevent setting to 1 when nPages is 0 initially
      setCurrentPage(1);
    }
  }, [currentPage, nPages]);

  useEffect(() => {
    if (validarTapped) {
      checkValidate();
    }
  }, [validarTapped]);

  useEffect(() => {
    if (deleteTapped) {
      setDeleteTapped(false);
      updateRecords();
    }
  }, [deleteTapped]);

  useEffect(() => {
    if (doCheckCreditLimit) {
      checkCreditLimit();
    }
  }, [doCheckCreditLimit]);

  useEffect(() => {
    updateRecords();
  }, [list, currentPage, recordsPerPage]); // Added list, currentPage, recordsPerPage as dependencies for updating records

  const handleFormData = (input) => (e) => {
    const { value } = e.target;

    const index = input.slice(-1);
    const field = input.slice(0, input.length - 1);

    const recordIndex = recordsPerPage * (currentPage - 1) + parseInt(index);

    if (field === "limite_mensual") {
      dispatch(
        updateVehicle(
          {
            ...list[recordIndex],
            credito_definido: parseInt(value),
            [field]: value,
          },
          recordIndex
        )
      );
      setDoCheckCreditLimit(true);
    } else {
      dispatch(
        updateVehicle(
          {
            ...list[recordIndex],
            [field]: value,
          },
          recordIndex
        )
      );
    }

    if (field !== "matricula") {
      setDoCheckCreditLimit(true);
    }
  };

  const checkValidate = async () => {
    const numberRegex = RegExp("[^0-9]");
    let hasAnyError = false;

    // Mapea la lista actual a una nueva lista de promesas de vehículos validados
    const validatedVehiclesPromises = list.map(async (element) => {
      const {
        matricula_error,
        tipo_combustible_error,
        tipo_vehiculo_error,
        pin_error,
        limite_mensual_error,
        limite_credito_error,
        ...vehicleData // El resto de los datos del vehículo
      } = element;
      let currentErrors = {};

      // Validar matricula
      const matriculaValida = await checkMatricula(element.matricula, token);
      if (matriculaValida?.code !== 200) {
        currentErrors.matricula_error =
          matriculaValida?.data ??
          t("flotas.modal.editar.form.btn-matricula-error");
      }

      if (element.tipo_combustible === "") {
        currentErrors.tipo_combustible_error = t(
          "flotas.modal.editar.form.btn-tipo-combustible-error"
        );
      }

      if (element.tipo_vehiculo === "") {
        currentErrors.tipo_vehiculo_error = t(
          "flotas.modal.editar.form.btn-tipo-vehiculo-error"
        );
      }
      const firstNumber = element.pin?.[0];
      if (
        element.pin && // Asegurarse de que pin exista
        element.pin.startsWith(`${firstNumber}${firstNumber}`) &&
        element.pin.endsWith(`${firstNumber}${firstNumber}`)
      ) {
        currentErrors.pin_error = t(
          "flotas.modal.editar.form.btn-pin-error-repetir"
        );
      } else if (
        !element.pin || // Si es null, undefined o ""
        element.pin.length !== 4 ||
        numberRegex.test(element.pin)
      ) {
        currentErrors.pin_error = t("flotas.modal.editar.form.btn-pin-error");
      }
      if (element.limite_credito === "") {
        currentErrors.limite_credito_error = t(
          "flotas.modal.editar.form.btn-limite-credito-error"
        );
      }
      if (
        (element.limite_credito === "Si" &&
          (!element.limite_mensual || element.limite_mensual === "0")) ||
        (element.limite_mensual && numberRegex.test(element.limite_mensual))
      ) {
        currentErrors.limite_mensual_error = t(
          "flotas.modal.editar.form.btn-limite-mensual-error"
        );
      }

      if (Object.keys(currentErrors).length > 0) {
        hasAnyError = true;
      }
      return { ...vehicleData, ...currentErrors };
    });

    // Esperar a que todas las validaciones (incluyendo las asíncronas) se completen
    const updatedListWithErrors = await Promise.all(validatedVehiclesPromises);

    // Despachar una única acción para actualizar toda la lista de vehículos
    dispatch(setVehicles(updatedListWithErrors));
    setIsAnyError(hasAnyError);

    onFormModified(false);
    setTimeout(() => {
      setValidarTapped(false);
    }, 100);
  };

  function updateRecords() {
    setCurrentRecords(
      typeof list !== "undefined"
        ? list.slice(indexOfFirstRecord, indexOfLastRecord)
        : data
    );
  }

  function checkCreditLimit() {
    let anyTrue = 0;
    list.forEach((e, index) => {
      if (e.limite_credito === "Si") {
        anyTrue++;
      } else {
        if (list[index].hasOwnProperty("limite_mensual_error")) {
          const { limite_mensual_error, ...updatedVehicle } = list[index];
          dispatch(
            updateVehicle(
              {
                ...updatedVehicle,
                limite_mensual: "0",
                credito_definido: -1,
                limite_credito: "No",
              },
              index
            )
          );
        } else {
          dispatch(
            updateVehicle(
              {
                ...list[index],
                limite_mensual: "0",
                credito_definido: -1,
                limite_credito: "No",
              },
              index
            )
          );
        }
      }
    });
    if (anyTrue > 0) {
      setCreditLimit(true);
    } else {
      setCreditLimit(false);
    }
    updateRecords();
    setValidarTapped(false);
    setTimeout(() => {
      setDoCheckCreditLimit(false);
    }, 100);
  }

  const isAnyVehicleSelected = (value) => {
    if (value) {
      onSelectVehicle(true);
    } else {
      let selectedVehicles = 0;
      const vehicles = document.querySelectorAll("div.vehiculo");
      vehicles.forEach((vehiculo) => {
        const checkbox = vehiculo.querySelector("input[type=checkbox]");
        if (checkbox.checked) {
          selectedVehicles++;
        }
      });
      if (selectedVehicles > 0) {
        onSelectVehicle(true);
      } else {
        onSelectVehicle(false);
      }
    }
  };

  return (
    <div>
      <Table
        className="flotas"
        borderless={true}
        hover={false}
        style={{
          overflow: "scroll",
        }}
      >
        <thead>
          <tr>
            <th style={{ width: "1%" }} className="flotas-download-title">
              <span>
                <Form.Check
                  type="checkbox"
                  className="flotas-table-select"
                  onClick={(e) => {
                    selectAllVehicles(e);
                    isAnyVehicleSelected(e.target.checked);
                  }}
                />
              </span>
            </th>
            <th className="flotas-table-header" style={{ width: "10%" }}>
              {t("flotas.table.matricula")}
              <span className="order-table-icons float-end"></span>
            </th>
            <th className="flotas-table-header" style={{ width: "10%" }}>
              {t("flotas.table.combustible")}
              <span className="order-table-icons float-end"></span>
            </th>
            <th className="flotas-table-header" style={{ width: "10%" }}>
              {t("flotas.table.vehiculo")}
              <span className="order-table-icons float-end"></span>
            </th>
            <th className="flotas-table-header" style={{ width: "7%" }}>
              {t("flotas.table.pin")}
              <span className="order-table-icons float-end"></span>
            </th>
            <th className="flotas-table-header" style={{ width: "7%" }}>
              {t("flotas.table.limite-credito")}
              <span className="order-table-icons float-end"></span>
            </th>
            {creditLimit && (
              <th className="flotas-table-header" style={{ width: "7%" }}>
                {t("flotas.table.limite-mensual")}
                <span className="order-table-icons float-end"></span>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {currentRecords.map((vehiculo, index) => (
            <tr key={vehiculo.matricula} id={"vehiculo-" + vehiculo.matricula}>
              <td className="flotas-download">
                {allVehicles ? (
                  <Form.Check
                    type="checkbox"
                    className="flotas-table-select vehiculo"
                    key={vehiculo.matricula}
                    value={vehiculo.matricula}
                    defaultChecked={allVehicles}
                    onClick={(e) => {
                      isAnyVehicleSelected(e.target.checked);
                    }}
                  />
                ) : (
                  <Form.Check
                    type="checkbox"
                    className="flotas-table-select vehiculo"
                    key={vehiculo.matricula}
                    value={vehiculo.matricula}
                    onClick={(e) => {
                      isAnyVehicleSelected(e.target.checked);
                    }}
                  />
                )}
              </td>
              <td className="flotas-matricula">
                <OverlayTrigger
                  key={1}
                  placement="bottom"
                  overlay={
                    vehiculo.hasOwnProperty("matricula_error") ? (
                      <Tooltip id={"tooltip1"}>
                        {vehiculo.matricula_error}
                      </Tooltip>
                    ) : (
                      <></>
                    )
                  }
                >
                  <Col className="m-1">
                    <Form.Control
                      key={vehiculo.matricula}
                      type="text"
                      maxLength="12"
                      id="flotas-registro-vehiculo-matricula"
                      defaultValue={vehiculo.matricula}
                      className={
                        vehiculo.hasOwnProperty("matricula_error")
                          ? "flotas-btn-error p-2"
                          : "p-2"
                      }
                      style={{ textAlign: "start" }}
                      onChange={handleFormData("matricula" + index)}
                      onBlur={() => {
                        handleFormData("matricula" + index);
                        updateRecords();
                        onFormModified(true);
                      }}
                    />
                    <Feedback type="invalid">
                      {t(
                        "flotas.registro-vehiculo.step-1.form.matricula.invalid"
                      )}
                    </Feedback>
                  </Col>
                </OverlayTrigger>
              </td>
              <td className="tipo_combustible">
                <OverlayTrigger
                  key={2}
                  placement="bottom"
                  overlay={
                    vehiculo.hasOwnProperty("tipo_combustible_error") ? (
                      <Tooltip id={"tooltip2"}>
                        {vehiculo.tipo_combustible_error}
                      </Tooltip>
                    ) : (
                      <></>
                    )
                  }
                >
                  <Col className="m-1">
                    <Form.Select
                      key={vehiculo.matricula}
                      aria-label={t(
                        "flotas.registro-vehiculo.step-1.form.combustible"
                      )}
                      id="flotas-registro-vehiculo-tipo-combustible"
                      defaultValue={vehiculo.tipo_combustible}
                      onChange={handleFormData("tipo_combustible" + index)}
                      onBlur={() => {
                        onFormModified(true);
                      }}
                      className={
                        vehiculo.hasOwnProperty("tipo_combustible_error")
                          ? "flotas-btn-error p-2"
                          : "p-2"
                      }
                      style={{
                        backgroundColor:
                          vehiculo.tipo_combustible ===
                          t("flotas.modal.nuevo.form.combustible.gasolina")
                            ? "#2ecc71"
                            : vehiculo.tipo_combustible === "Diesel"
                            ? "#fca534"
                            : "#ececec",
                        color:
                          vehiculo.tipo_combustible !== "Diesel" &&
                          vehiculo.tipo_combustible !==
                            t("flotas.modal.nuevo.form.combustible.gasolina")
                            ? "#000"
                            : "#fff",
                      }}
                    >
                      <option
                        value=""
                        disabled
                        style={{ backgroundColor: "#ececec" }}
                      >
                        {t("flotas.modal.editar.form.elige-combustible")}
                      </option>
                      <option
                        value="Diesel"
                        style={{
                          color: "#000",
                          backgroundColor: "#ececec",
                        }}
                      >
                        {t("flotas.modal.nuevo.form.combustible.diesel")}
                      </option>
                      <option
                        style={{
                          color: "#000",
                          backgroundColor: "#ececec",
                        }}
                        value="Gasolina"
                      >
                        {t("flotas.modal.nuevo.form.combustible.gasolina")}
                      </option>
                    </Form.Select>
                    <Feedback type="invalid">
                      {t(
                        "flotas.registro-vehiculo.step-1.form.combustible.invalid"
                      )}
                    </Feedback>
                  </Col>
                </OverlayTrigger>
              </td>
              <td className="flotas-vehiculo">
                <OverlayTrigger
                  key={3}
                  placement="bottom"
                  overlay={
                    vehiculo.hasOwnProperty("tipo_vehiculo_error") ? (
                      <Tooltip id={"tooltip3"}>
                        {vehiculo.tipo_vehiculo_error}
                      </Tooltip>
                    ) : (
                      <></>
                    )
                  }
                >
                  <Col className="m-1">
                    <Form.Select
                      key={vehiculo.matricula}
                      aria-label={t(
                        "flotas.registro-vehiculo.step-1.form.tipo-vehiculo"
                      )}
                      id="flotas-registro-vehiculo-tipo-vehiculo"
                      defaultValue={vehiculo.tipo_vehiculo}
                      onChange={handleFormData("tipo_vehiculo" + index)}
                      onBlur={() => {
                        onFormModified(true);
                      }}
                      className={
                        vehiculo.hasOwnProperty("tipo_vehiculo_error")
                          ? "flotas-btn-error p-2"
                          : "p-2"
                      }
                      pattern="[0-9]{4}[B-DF-HJ-NP-TV-Z]{3}"
                    >
                      <option value="" disabled>
                        {t("flotas.modal.editar.form.tipo-vehiculo.select")}
                      </option>
                      <option value="Turismo">
                        {t("flotas.modal.nuevo.form.tipo.turismo")}
                      </option>
                      <option value="Motocicleta">
                        {t("datos.modal.editar.form.tipo-vehiculo.moto")}
                      </option>
                      <option value="Camión">
                        {t("flotas.modal.nuevo.form.tipo.camion")}
                      </option>
                    </Form.Select>
                    <Feedback type="invalid">
                      {t(
                        "flotas.registro-vehiculo.step-1.form.tipo-vehiculo.invalid"
                      )}
                    </Feedback>
                  </Col>
                </OverlayTrigger>
              </td>
              <td className="flotas-pin">
                <OverlayTrigger
                  key={4}
                  placement="bottom"
                  overlay={
                    vehiculo.hasOwnProperty("pin_error") ? (
                      <Tooltip id={"tooltip4"}>{vehiculo.pin_error}</Tooltip>
                    ) : (
                      <></>
                    )
                  }
                >
                  <Col className="m-1">
                    <Form.Control
                      key={vehiculo.matricula}
                      type="text"
                      id="flotas-registro-vehiculo-pin-input"
                      defaultValue={vehiculo.pin}
                      maxLength="4"
                      pattern="[0-9]{4}"
                      required
                      className={
                        vehiculo.hasOwnProperty("pin_error")
                          ? "flotas-btn-error p-2"
                          : "p-2"
                      }
                      style={{ textAlign: "start" }}
                      onChange={handleFormData("pin" + index)}
                      onBlur={() => {
                        onFormModified(true);
                      }}
                    />
                    <Feedback type="invalid">
                      {t(
                        "flotas.registro-vehiculo.step-1.form.pin-input.invalid"
                      )}
                    </Feedback>
                  </Col>
                </OverlayTrigger>
              </td>
              <td className="flotas-precio">
                <OverlayTrigger
                  key={5}
                  placement="bottom"
                  overlay={
                    vehiculo.hasOwnProperty("limite_credito_error") ? (
                      <Tooltip id={"tooltip5"}>
                        {vehiculo.limite_credito_error}
                      </Tooltip>
                    ) : (
                      <></>
                    )
                  }
                >
                  <Col className="m-1">
                    <Form.Select
                      key={vehiculo.matricula}
                      aria-label={t(
                        "flotas.registro-vehiculo.step-1.form.limite-credito"
                      )}
                      id="flotas-registro-vehiculo-limite-credito"
                      defaultValue={vehiculo.limite_credito}
                      onChange={handleFormData("limite_credito" + index)}
                      onBlur={() => {
                        onFormModified(true);
                      }}
                      className={
                        vehiculo.hasOwnProperty("limite_credito_error")
                          ? "flotas-btn-error p-2"
                          : "p-2"
                      }
                    >
                      <option value="" disabled>
                        {t("flotas.modal.editar.form.limite-credito.select")}
                      </option>
                      <option value="No">
                        {t("flotas.modal.editar.form.factura.no")}
                      </option>
                      <option value="Si">
                        {t("flotas.modal.editar.form.factura.si")}
                      </option>
                    </Form.Select>
                    <Feedback type="invalid">
                      {t(
                        "flotas.registro-vehiculo.step-1.form.limite-credito.invalid"
                      )}
                    </Feedback>
                  </Col>
                </OverlayTrigger>
              </td>
              {creditLimit ? (
                <td className="flotas-precio">
                  <OverlayTrigger
                    key={6}
                    placement="bottom"
                    overlay={
                      vehiculo.hasOwnProperty("limite_mensual_error") ? (
                        <Tooltip id={"tooltip6"}>
                          {vehiculo.limite_mensual_error}
                        </Tooltip>
                      ) : (
                        <></>
                      )
                    }
                  >
                    <Col className="m-1">
                      {" "}
                      <Form.Control
                        key={vehiculo.matricula}
                        type="text"
                        id="flotas-registro-vehiculo-limit-value"
                        defaultValue={vehiculo.limite_mensual}
                        pattern="[0-9]"
                        required
                        className={
                          vehiculo.hasOwnProperty("limite_mensual_error")
                            ? "flotas-btn-error p-2"
                            : "p-2"
                        }
                        style={{ textAlign: "start" }}
                        onChange={handleFormData("limite_mensual" + index)}
                        onBlur={() => {
                          onFormModified(true);
                        }}
                        disabled={vehiculo.limite_credito === "No"}
                      />
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-1.form.limit-value.invalid"
                        )}
                      </Feedback>
                    </Col>
                  </OverlayTrigger>
                </td>
              ) : (
                <></>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        nPages={nPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        recordsPerPage={recordsPerPage}
        totalRecords={currentRecords.length}
        setRecordsPerPage={setRecordsPerPage}
      />
    </div>
  );
};
